module.exports = __webpack_public_path__ + "assets/ParrotMic.99c53872.svg";